/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-len */
/* eslint-disable no-void */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable object-curly-newline */
import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ListItemButton from "@mui/material/ListItemButton";
import Typography from "@mui/material/Typography";

import Environments from "../../Environments";
import { MESSAGE_KIND_GET } from "../../Constants";
import MOCK_DATA from "../../mock/data";

import NoData from "../../component/NoData";
import WhatsNewIcon from "../../component/icons/WhatsNewIcon";
import BaseFrame from "../../component/wrapper/BaseFrame";
import { HomeLink } from "../../component/breadcrums/Links";
import Pagination, { viewTypes } from "../../component/pagination/Pagination";
import SompoLoading from "../../component/loading/SompoLoading";

import NoticeMessageListService, { NoticeMessageListResponse, MsgListItem } from "../../logic/api/NoticeMessageListService";
import NoticeWhatsNewListService, { NoticeWhatsNewListResponse, WhatsNewListItem } from "../../logic/api/NoticeWhatsNewListService";
import { datetime2DateJP } from "../../logic/datetime";
import { isNew } from "../../logic/information/Information";
import { getTextFromHTML } from "../../logic/text";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import { desc } from "../../logic/utility/sort";
import SompoContext from "../../logic/context/SompoContext";

const messageService = new NoticeMessageListService();
const whatsService = new NoticeWhatsNewListService();

interface InfoItem {
    messageId: string;
    startDateStr: string;
    title: string;
    message: string;
    whatsNew?: boolean;
}

function convertMessage(messageList: string[]) {
    if (messageList === null || messageList.length === 0) {
        return "";
    }
    // 各配列の文字列を結合
    const allMessage = messageList.join("");
    return allMessage;
}

// 実際に表示されるコンポーネント
const Content = () => {
    const navigate = useNavigate();
    const [info, setInfo] = useState<InfoItem[]>([]);
    const [viewInfo, setViewInfo] = useState<InfoItem[]>([]);
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用

    useEffect(() => {
        sompoContext.setLoading(true); // ローディング開始
        const newInfo: InfoItem[] = [];

        if (!Environments.MOCK) {
            const fetch = async () => {
                try {
                    // メッセージ一覧を取得
                    await messageService.noticeMessageList(
                        { kind: MESSAGE_KIND_GET },
                        (_info: NoticeMessageListResponse) =>
                            (_info.msgList || []).forEach((datum: MsgListItem) => {
                                newInfo.push({
                                    messageId: datum.messageId,
                                    startDateStr: datum.startDateStr,
                                    title: datum.title,
                                    message: convertMessage(datum.messageList),
                                });
                            }),
                        (error: any) => {
                            throw error;
                        }
                    );

                    // What's New一覧を取得
                    await whatsService.noticeWhatsNewList(
                        {},
                        (_info: NoticeWhatsNewListResponse) =>
                            (_info.whatsNewList || []).forEach((datum: WhatsNewListItem) => {
                                newInfo.push({
                                    whatsNew: true,
                                    messageId: datum.messageId,
                                    startDateStr: datum.startDateStr,
                                    title: datum.titleList[0],
                                    message: convertMessage(datum.messageList),
                                });
                            }),
                        (error: any) => {
                            throw error;
                        }
                    );
                    setInfo(newInfo.sort((a, b) => desc(a.startDateStr, b.startDateStr)));
                    sompoContext.setLoading(false); // ローディング終了
                } catch (error: any) {
                    console.error(error);
                    showErrorMessage({ message: "お知らせの取得に失敗しました。", error });
                    setInfo([]);
                    sompoContext.setLoading(false); // ローディング終了
                }
            };
            void fetch();
        } else {
            (MOCK_DATA.INFORMATION.whatsNewList || []).forEach((datum: WhatsNewListItem) => {
                newInfo.push({
                    whatsNew: true,
                    messageId: datum.messageId,
                    startDateStr: datum.startDateStr,
                    title: datum.titleList[0],
                    message: convertMessage(datum.messageList),
                });
            });
            (MOCK_DATA.INFORMATION.msgList || []).forEach((datum: MsgListItem) => {
                newInfo.push({
                    messageId: datum.messageId,
                    startDateStr: datum.startDateStr,
                    title: datum.title,
                    message: convertMessage(datum.messageList),
                });
            });
            setInfo(newInfo.sort((a, b) => (a.startDateStr < b.startDateStr ? 1 : -1)));
            sompoContext.setLoading(false); // ローディング終了
        }
    }, []);

    /**
     * カードのスタイルを作成する
     * 先頭、末尾のみ丸みをつける
     * @param index
     * @returns
     */
    const cardStyle = (index: number) => {
        let style = {
            width: "100%",
            bgcolor: "background.paper",
            mb: "1px",
            borderRadius: "0 0 0 0",
        };
        if (index === 0) {
            style = {
                ...style,
                borderRadius: "5px 5px 0 0",
            };
        } else if (index === viewInfo.length - 1) {
            style = {
                ...style,
                mb: "0",
                borderRadius: "0 0 5px 5px",
            };
        }
        return style;
    };

    return (
        <Grid container direction="column" alignItems="center" justifyContent="flex-start" sx={{ width: "100%", margin: "auto", mb: 2 }}>
            {/* fetchが終わるまでローディングアイコンを表示 */}
            {sompoContext.loading ? (
                <SompoLoading />
            ) : (
                <Grid item sx={{ width: "100%", height: "100%", mb: 1 }}>
                    {info && info.length > 0 ? (
                        <>
                            {viewInfo.map((row, index) => {
                                let detail: string;
                                switch (row.whatsNew) {
                                    case true:
                                        detail = "whatsnew";
                                        break;
                                    default:
                                        detail = "message";
                                }
                                return (
                                    <Box key={index} sx={cardStyle(index)}>
                                        <ListItemButton
                                            sx={{
                                                transition: "all 0.18s ease-in-out",
                                                "&:hover": {
                                                    bgcolor: "#ddd",
                                                    cursor: "pointer",
                                                    width: "100%",
                                                },
                                            }}
                                            onClick={() => {
                                                navigate(`/information/${detail}/${row.messageId}`);
                                            }}
                                        >
                                            <Grid item container direction="row">
                                                {/** 日付け */}
                                                <Grid item xs={12} sm={3} md={2} sx={{ minWidth: { xs: "120px" } }}>
                                                    <Typography sx={{ fontSize: "0.9rem" }}>{datetime2DateJP(row.startDateStr)}</Typography>
                                                </Grid>
                                                {/** newアイコン */}
                                                <Grid item xs={3} sm={2} md={2} sx={{ px: 1 }}>
                                                    {isNew(row.startDateStr) && <WhatsNewIcon />}
                                                </Grid>
                                                {/** タイトル */}
                                                <Grid item xs>
                                                    <Typography
                                                        className="ellipses"
                                                        sx={{
                                                            fontWeight: "bold",
                                                            overflow: "hidden",
                                                            wordBreak: "break-all",
                                                        }}
                                                    >
                                                        {getTextFromHTML(row.title)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemButton>
                                    </Box>
                                );
                            })}
                            {/** ページネーション */}
                            <Pagination viewType={viewTypes.VIEW_TYPE_CASES} data={info} viewCases={10} setViewData={setViewInfo} />
                        </>
                    ) : (
                        <NoData message="表示データがありません" />
                    )}
                </Grid>
            )}
        </Grid>
    );
};

const Information = () => (
    <>
        <BaseFrame width="70%" title="お知らせ" breadcrumbs={[<HomeLink />]} content={<Content />} />
    </>
);

export default Information;
